<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ truncate(activeUserInfo.displayName, 20) }}
        </p>
        <!-- <span class="user-status">{{ userData.role }}</span> -->
      </div>
      <b-avatar
        size="40"
        :src="activeUserInfo.profile_picture"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!activeUserInfo.name"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Perfil</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Sair</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import { avatarText } from '@core/utils/filter'
import { isAdmin } from '@/util/Util'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      key: 0,
      avatarText,
    }
  },
  watch: {
    '$store.state.AppActiveUser'(val) {
      this.key++
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    userPeople() {
      return this.activeUserInfo.people
    },
    avatarText() {
      const names = this.activeUserInfo.displayName.split(' ')
      const fisrtName = names[0][0].toUpperCase()
      let secontName = ''
      if (names.length > 1) {
        secontName = names[1][0].toUpperCase()
      }
      return fisrtName + secontName
    },
    activeProfile() {
      return this.$t(this._.upperFirst(this.$store.getters.activeProfile))
    },
    showActiveProfile() {
      return isAdmin()
    },
    userHasPerson() {
      return (
        this.userPeople && this.userPeople.length > 0
      ) || false
    }
  },
  methods: {
    logout() {
    
      // Reset ability
      // this.$ability.update(initialAbility)

      this.$store.dispatch('auth/logout', {vs: this.$vs})
    }
  },
}
</script>
